import { recipe } from './recipeData';

/******
 * Callback functions for the
 * ingredients array
 */
export const sumIngredientType = (type, arr = recipe.ingredients) => {
  let sum = 0;
  arr.forEach((el) => {
    if (el.type.toLowerCase() === type.toLowerCase()) sum += el.qty;
  });
  return sum;
};

export const getIngredientByType = (type, arr = recipe.ingredients) => {
  const objIndex = arr.findIndex(
    (el) => el.type.toLowerCase() === type.toLowerCase()
  );
  return arr[objIndex];
};

export const getIngredientByName = (name, arr = recipe.ingredients) => {
  const objIndex = arr.findIndex(
    (el) => el.name.toLowerCase() === name.toLowerCase()
  );
  return arr[objIndex];
};

/**
 * Function to return flour and water amounts from
 * an hydration ratio. Useful for levain and for doughs.
 *
 * @param {number} mass
 * @param {number: percent as decimal} hydration
 */
const hydrationBreakdown = (mass, hydration) => {
  const flour = mass / (1 + hydration);
  const liquid = mass - flour;
  return {
    mass: mass,
    hydration: hydration,
    flour: flour,
    liquid: liquid,
  };
};

/****
 * Updates the overall recipe stats
 */

const calcDoughPct = () => {
  calcDoughMass();
  recipe.ingredients.forEach((el) => {
    el.doughPct = el.qty / recipe.doughMass;
  });
};

const calcBPct = () => {
  recipe.ingredients.forEach((el) => {
    el.BPct = el.qty / sumIngredientType('flour');
  });
};

export const getDoughMass = (excludeMixIns = false) => {
  let total = 0;

  if (excludeMixIns === true) {
    recipe.ingredients.forEach((el) => {
      if (
        el.type === 'flour' ||
        el.type === 'liquid' ||
        el.type === 'preferment' ||
        el.type === 'salt'
      )
        total += el.qty;
    });
    return total;
  } else {
    recipe.ingredients.forEach((el) => (total += el.qty));
    return total;
  }
};

const calcDoughMass = (excludeMixIns = false) => {
  recipe.doughMass = getDoughMass(excludeMixIns);
};

const calcEndHydration = () => {
  let totalFlour = 0;
  let totalWater = 0;

  // get the flour from levain
  const preferment = getIngredientByType('preferment');
  const prefermentObj = hydrationBreakdown(
    preferment.qty,
    preferment.hydration
  );
  totalFlour = prefermentObj.flour + sumIngredientType('flour');

  // add the waters
  totalWater = getIngredientByType('liquid').qty + prefermentObj.liquid;
  // update the end hydration
  recipe.endHydration = totalWater / totalFlour;
};

const calcBakersHydration = () => {
  recipe.bakersHydration =
    getIngredientByType('liquid').qty / sumIngredientType('flour');
};

export const updateDoughStats = () => {
  calcDoughMass();
  calcBakersHydration();
  calcEndHydration();
  calcDoughPct();
  calcBPct();
};

/**
 * Functions to mutate the recipe
 */

// Make more or less dough, while keeping the ingredient
// percentages constant
export const scaleDoughMass = (
  newMass,
  numLoaves = 1,
  excludeMixIns = false
) => {
  if (newMass > 0) {
    const massMultiplier = newMass / getDoughMass(excludeMixIns);
    recipe.ingredients.forEach((el) => {
      el.qty = el.qty * massMultiplier * numLoaves;
    });
    recipe.numLoaves = numLoaves;
  }
};

export const setLoafNum = (loafNum) => {
  if (loafNum > 0) {
    recipe.ingredients.forEach(
      (el) => (el.qty = el.qty * (loafNum / recipe.numLoaves))
    );
    recipe.numLoaves = loafNum;
  }
};

// Increase the amount of flour or liquid in the recipe
// while keeping the dough mass dough mass the same

export const changeBakersHydration = (newHydration) => {
  const mass = getDoughMass();

  // get your new flour and water totals
  const loafHydroObj = hydrationBreakdown(recipe.doughMass, newHydration);

  // update the water prop
  getIngredientByType('liquid').qty = loafHydroObj.liquid;

  // scale flour up or down, keeping the ratio of flours fixed
  const flourMultipler = loafHydroObj.flour / sumIngredientType('flour');
  recipe.ingredients.forEach((el) => {
    if (el.type === 'flour') el.qty *= flourMultipler;
  });

  // Set the mass back to the right size and update stats
  scaleDoughMass(mass / recipe.numLoaves, recipe.numLoaves);
  updateDoughStats();
};

// Add a new ingredient to the array, then update the overall
// recipe stats to reflect the change
export const modIngredient = (ingName, newQty) => {
  if (getIngredientByName(ingName).qty) {
    getIngredientByName(ingName).qty = newQty;
    updateDoughStats();
  } else {
    console.log(
      `Could not modify ${ingName} because the element was not found in the recipe.`
    );
  }
};

// delete an ingredient
export const deleteIngredient = (ingName) => {
  recipe.ingredients = recipe.ingredients.filter((el) => el.name !== ingName);
};

// add new ingredient
export const addIngredient = (name, qty, type, hydration) => {
  if (hydration) {
    recipe.ingredients.push({
      name,
      qty,
      type: type.toLowerCase(),
      hydration,
    });
  } else {
    recipe.ingredients.push({
      name,
      qty,
      type: type.toLowerCase(),
    });
  }
};

/**
 *
 * @param {number} bakersPct
 * @param {number} recipeFlour
 * @param {number} type OPTIONAL Parameter - default to non-flour
 */
export const getQuantFromBakers = (bakersPct, recipeFlour, type) => {
  if (type === 'flour') {
    return bakersPct * recipeFlour;
  } else {
    return bakersPct * recipeFlour;
  }
};

export const getBakersFromQuantity = (
  newIngQuantity,
  recipeFlour,
  type = ''
) => {
  if (type === 'flour') {
    return newIngQuantity / (recipeFlour + newIngQuantity);
  } else {
    return newIngQuantity / recipeFlour;
  }
};
